<div class="table-view busy-overlay-parent" [ngClass]="isLoading||!appState.isReady?'disabled':''">

    <div *ngIf="isLoading||!appState.isReady" class="font-weight-bold busy-overlay">
      <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
    </div>

    <div *ngIf="errorMsg" class="alert alert-danger d-flex flex-row justify-content-between">
      <div>{{errorMsg}}</div>
      <div class="">
          <i class="fa fa-times" role="button" (click)="errorMsg=null"></i>
      </div>
    </div>

    <div class="table-view-header-controls" style="position:sticky;left:0;">
    <div class="d-flex flex-wrap">
      <div class="px-2" style="font-size:18px;font-weight: bold;">
        Path Points
      </div>
      <div class="d-flex flex-row">
        <ng-template #configModal>
          <div class="m-0 p-1 modal-header font-weight-bold" style="background-color: #CFD5EA;">
            Table Options
            <button type="button" class="close pull-right" aria-label="Close" (click)="closeConfigModal(configComponent)">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <fes-table-view-config  #configComponent [table]="this" [pagingEnabled]="false"
                (filterKeyUp)="$event.event.key=='Enter'&&closeConfigModal(configComponent)">
            </fes-table-view-config>
          </div>
          <div class="m-0 p-1 modal-footer d-flex flex-row justify-content-between">
            <div></div>
            <button class="btn btn-warning" (click)="closeConfigModal(configComponent)">Close</button>
          </div>
        </ng-template>
        <div class="pl-2 my-auto small">
          <a href="javascript:false;" (click)="showConfigModal(configModal)">
            <i class="fa fa-columns px-sm-1"></i>
          </a>
          &nbsp;
          <a href="javascript:false;" (click)="!bDownloading&&download()" [ngStyle]="{'opacity':bDownloading?'0.2':'1'}">
            <i [ngClass]="'fa fa-download' + (bDownloading?' blink':'')"></i>
          </a>
        </div>
      </div>

    </div>
    </div>



    <div class="p-2 table-view-table-wrapper">
      <table class="table-view-table table">
        <thead>
          <tr>
            <th *ngFor="let column of visibleColumns; index as visibleIndex;" role="button"
              class="p-0 align-bottom" [ngClass]="column.headerCellCssClass">
              <div class="d-flex flex-row justify-content-between">
                <div class="w-100 py-sm-1 text-center" (click)="column.name&&sort(column.name)">{{column.title}}</div>
                <div class="d-flex flex-column justify-content-end">
                  <div class="d-flex flex-row">
                    <div class="px-1 small" *ngIf="column.name=='pathDescription'">
                      <input type="checkbox" [(ngModel)]="wordWrapDescription"
                          class="form-check-input" style="margin-left:-.85rem;" name="wordWrapDescription"/>
                      <label class="pt-1 font-italic form-check-label" for="wordWrapDescription">
                        wrap
                      </label>
                    </div>
                    <app-table-dropdown-filter [sortKey]="sortColumns[0]?.key" [column]="column"
                      [visibleIndex]="visibleIndex"
                      [bSortAscending]="sortColumns[0]?.order=='ASC'" (closed)="reload()">
                    </app-table-dropdown-filter>
                  </div>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let record of records;index as index;">
            <tr *ngIf="(!sortColumns?.length||sortColumns[0].key=='pathName')&&(index==0||record.pathName!=records[index-1].pathName)" class="path-description-row">
              <td *ngIf="columnByName['buildingId']?.visible" (dblclick)="onDataCellDblClick(columnByName['buildingId'],record)" role="button">
                <div>{{record.buildingId}}</div>
              </td>
              <td *ngIf="columnByName['pathName']?.visible" (dblclick)="onDataCellDblClick(columnByName['pathName'],record)" role="button">
                <div>{{record.pathName}}</div>
              </td>
              <td [attr.colspan]="1"
                (dblclick)="onDataCellDblClick(columnByName['pathDescription'],record)" role="button">
                <div class="text-left" [ngClass]="wordWrapDescription?'text-wrap':''">
                  {{record.pathDescription}}
                </div>
              </td>
            </tr>
            <tr [ngClass]="record.point&&record.point.id==selectedRecord?.point?.id?'selected':''" (click)="selectedRecord=record">
            <ng-container *ngFor="let column of visibleColumns;">
              <td [ngSwitch]="column.template" [ngClass]="column.dataCellCssClass" role="button" (dblclick)="onDataCellDblClick(column,record)">
                <div *ngSwitchCase="'percent'" [ngClass]="{'text-super-muted':record[column.name]==0}">{{record[column.name]|percent:'.0-2'}}</div>
                <div *ngSwitchCase="'numeric'" [ngClass]="record[column.name]==0?'text-super-muted':'text-blue'">{{record[column.name]||'-'}}</div>
                <div *ngSwitchCase="'text'">{{record[column.name]}}</div>
                <div *ngSwitchCase="'type'" [ngClass]="'point-type-' + record['type']">{{record[column.name]}}</div>
                <div *ngSwitchCase="'scoutPointBtn'">{{record[column.name]}}</div>
                <div *ngSwitchCase="'empty'"></div>
                <ng-container *ngSwitchDefault>{{record[column.name]}}</ng-container>
              </td>
            </ng-container>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <div *ngIf="!isLoading&&records.length==0" class="pt-2 text-center text-warning">
        No Path Points Found.
      </div>
    </div>

  </div>

